const tableRows = [
  { taskType: 'Регулярные операционные задачи', who: 'Сотрудники с соответствующими должностными обязанностями', control: 'Периодический, по результату' },
  { taskType: 'Сбор и подготовка информации', who: 'Сотрудники с аналитическими компетенциями', control: 'Проверка структуры и ключевых данных' },
  { taskType: 'Подготовка отчётов и презентаций', who: 'Сотрудники, знакомые с темой и форматом', control: 'Промежуточная проверка содержания' },
  { taskType: 'Коммуникация с внутренними подразделениями', who: 'Руководители среднего звена и старшие специалисты', control: 'По ключевым договорённостям' },
  { taskType: 'Развивающие задачи', who: 'Сотрудники с высоким потенциалом', control: 'Более частый на старте, затем — по результату' },
  { taskType: 'Стратегические решения', who: 'Только руководитель', control: 'Не делегируется' },
  { taskType: 'Ключевые переговоры с партнёрами', who: 'Только руководитель', control: 'Не делегируется' },
  { taskType: 'Задачи с высокими рисками', who: 'Опытные сотрудники под контролем руководителя', control: 'Частые контрольные точки' },
];

export default function WhoAndWhatToDelegate() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Кому и что делегировать
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Не все задачи можно делегировать, и не всем сотрудникам — одинаковые задачи
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {[
            { title: 'Какие задачи делегировать', desc: 'Регулярные операционные задачи, сбор информации, подготовку материалов, развивающие задачи, задачи с понятным результатом и низким риском ошибки.' },
            { title: 'Какие задачи сохранять за собой', desc: 'Стратегические решения, ключевые переговоры, задачи с высокими рисками, антикризисное управление, развитие ключевых сотрудников.' },
            { title: 'Учитывайте компетентность', desc: 'Чем выше компетентность сотрудника, тем сложнее задачи можно делегировать и тем меньше контроля требуется.' },
            { title: 'Учитывайте мотивацию', desc: 'Низкая мотивация при высокой компетенции — сигнал, что сотруднику нужны новые вызовы и развивающие задачи.' },
            { title: 'Учитывайте загрузку', desc: 'Делегирование перегруженному сотруднику приведёт к срыву сроков. Проверяйте текущую загрузку перед передачей задачи.' },
            { title: 'Не превращайте в сброс работы', desc: 'Делегирование неприятных задач без объяснения контекста разрушает доверие. Сотрудник должен понимать, почему задача важна.' },
          ].map((item) => (
            <div key={item.title} className="bg-gray-50 rounded-xl border border-gray-200 p-4 md:p-5 hover:border-teal-300 transition-colors">
              <h3 className="font-bold text-gray-900 text-sm mb-1.5">{item.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        <div className="overflow-x-auto rounded-xl border border-gray-200">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-teal-600 text-white">
                <th className="text-left px-4 py-3 font-semibold text-xs">Тип задачи</th>
                <th className="text-left px-4 py-3 font-semibold text-xs">Кому делегировать</th>
                <th className="text-left px-4 py-3 font-semibold text-xs">Какой контроль нужен</th>
              </tr>
            </thead>
            <tbody>
              {tableRows.map((row, i) => (
                <tr key={i} className={`border-t border-gray-100 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}>
                  <td className="px-4 py-3 text-xs text-gray-800 font-medium">{row.taskType}</td>
                  <td className="px-4 py-3 text-xs text-gray-600">{row.who}</td>
                  <td className="px-4 py-3 text-xs text-gray-600">{row.control}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}